import { MRP_LOCATION_PUBLIC_LOCATION_ID, type MrpLocation } from "@/lib/mrp";
import {
  batchDetailsSearchFromUrlParams,
  type BatchDetailsUrlSearchParams,
} from "@/lib/batchDetailsSearch";

export type { BatchDetailsUrlSearchParams };
export { batchDetailsSearchFromUrlParams };

const EDIT_BATCH_SITE_KEYS = ["sgs", "suntronic"] as const satisfies readonly MrpLocation[];

/** Both sites so edit-batch can list SGS and Suntronic batches at the same ship-to (incoming orders parity). */
export const EDIT_BATCH_BOTH_SITES_LOCATION_PARAM = EDIT_BATCH_SITE_KEYS.map((key) =>
  String(MRP_LOCATION_PUBLIC_LOCATION_ID[key]),
).join(",");

/** Incoming orders and other sales-order-first entry points. */
export function buildManufacturingEditBatchPath(input: {
  salesOrderId: number;
  batchId?: number | null;
}): string {
  const params = new URLSearchParams();
  params.set("sales_order_id", String(input.salesOrderId));
  params.set("location", EDIT_BATCH_BOTH_SITES_LOCATION_PARAM);
  if (input.batchId != null && input.batchId > 0) {
    params.set("batch_id", String(input.batchId));
  }
  return `/manufacturing-management/edit-batch?${params.toString()}`;
}

/** Production calendar, batch details, and other batch-first entry points (address on the batch row). */
export function buildManufacturingEditBatchPathForBatch(batchId: number): string {
  const params = new URLSearchParams();
  params.set("batch_id", String(batchId));
  params.set("location", EDIT_BATCH_BOTH_SITES_LOCATION_PARAM);
  return `/manufacturing-management/edit-batch?${params.toString()}`;
}

export const EDIT_BATCH_ENTRY_REQUIRED_HOVER_HINT =
  "Open Edit batch from a batch or sales order link. The page groups batches and orders by ship-to address.";

/** Opens Batch details with this batch selected. Does not filter the list. */
export function buildManufacturingBatchDetailsPath(batchId: number): string {
  const params = new URLSearchParams();
  params.set("batch_id", String(batchId));
  return `/manufacturing-management/batch-details?${params.toString()}`;
}
